import { render, staticRenderFns } from "./leadListItem.vue?vue&type=template&id=85d479ce&lang=pug"
import script from "./leadListItem.vue?vue&type=script&lang=js"
export * from "./leadListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports